    <div class="fixed inset-0 z-[10000] flex items-center justify-center p-4" role="dialog" aria-modal="true" [attr.aria-labelledby]="titleId">
      <div class="absolute inset-0 bg-dark-text/60 backdrop-blur-sm" (click)="cancel()"></div>
      <div cntFocusTrap (escape)="cancel()"
        class="relative bg-white rounded-2xl shadow-[0_24px_48px_rgba(0,0,0,0.2)] max-w-md w-full p-6 md:p-7">
        <div class="inline-flex items-center justify-center w-11 h-11 rounded-full bg-jungle-green/10 text-jungle-green mb-3">
          <span aria-hidden="true" class="material-symbols-outlined text-2xl">content_copy</span>
        </div>
        <h2 [id]="titleId" class="font-headline font-bold text-dark-text text-xl md:text-2xl tracking-tight mb-1">
          Name your copy
        </h2>
        <p class="text-sm text-muted-text font-body leading-relaxed mb-4">{{ subtitle }}</p>

        <label class="block">
          <span class="text-xs font-label uppercase tracking-[0.12em] font-bold text-dark-text">Title</span>
          <input #input type="text" [(ngModel)]="value" name="copyTitle" maxlength="80"
            (keydown.enter)="save()"
            class="mt-1 w-full bg-cream/60 border border-dark-text/15 rounded-lg px-3 py-2.5 text-sm font-body focus:outline-none focus:border-jungle-green">
        </label>

        <div class="flex flex-col sm:flex-row sm:justify-end gap-2 mt-5">
          <button type="button" (click)="cancel()"
            class="px-4 py-2 rounded-full bg-white border border-dark-text/15 text-muted-text text-[0.65rem] uppercase tracking-[0.12em] font-button font-bold hover:border-dark-text transition-colors">
            Cancel
          </button>
          @if (showSaveToDrafts) {
            <button type="button" (click)="saveToShelf()" [disabled]="!value.trim()"
              class="inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-full bg-white border border-jungle-green/30 text-jungle-green text-[0.65rem] uppercase tracking-[0.12em] font-button font-bold hover:bg-jungle-green/10 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
              <span aria-hidden="true" class="material-symbols-outlined text-base">bookmark_add</span>
              Save to drafts
            </button>
          }
          <button type="button" (click)="save()" [disabled]="!value.trim()"
            class="inline-flex items-center justify-center gap-1.5 px-5 py-2 rounded-full bg-trinidad text-white text-[0.65rem] uppercase tracking-[0.12em] font-button font-bold hover:opacity-95 disabled:opacity-40 disabled:cursor-not-allowed shadow-[0_6px_16px_rgba(227,83,13,0.25)]">
            <span aria-hidden="true" class="material-symbols-outlined text-base">{{ showSaveToDrafts ? 'open_in_new' : 'save' }}</span>
            {{ showSaveToDrafts ? 'Save copy & open' : 'Save copy' }}
          </button>
        </div>
        @if (showQuickPublish) {
          <div class="mt-3 text-right">
            <button type="button" (click)="quickPublish()" [disabled]="!value.trim()"
              class="inline-flex items-center gap-1 text-[0.65rem] uppercase tracking-[0.12em] font-button font-bold text-trinidad hover:underline disabled:opacity-40 disabled:cursor-not-allowed disabled:no-underline">
              <span aria-hidden="true" class="material-symbols-outlined text-sm">bolt</span>
              Or publish as-is →
            </button>
          </div>
        }
      </div>
    </div>
